import { GetServerSidePropsContext } from 'next';
const testing = (process.env.NODE_TEST as string) === 'testing';
const development = (process.env.NODE_ENV as string) === 'development';

export const getGSSPPageData = async (ctx: GetServerSidePropsContext) => {
  // Log user in if we are receiving POST one time login data.
  // const appProps = await App.getInitialProps(ctx);

  // We always want to send the backend the path without the language.
  const pathWithoutLocale = ctx.resolvedUrl?.replace(
    `/${ctx.locale ?? ''}`,
    '',
  );

  const protocol = !testing && !development ? 'https' : 'http';

  const { headers = {} } = ctx.req || (window as any).__NEXT_DATA__.props;

  let host = `${protocol}://${headers.host}`;
  if (ctx.req) {
    host = `${protocol}://${headers.host}`;
  } else {
    host = window.location.origin;
  }

  return {
    path: pathWithoutLocale,
    host,
  };
};
